import React from 'react'
import Button from '../../../UI/UIComponent/Button';
import consultations from '../../../StaticData/hospitalConsultations.json';
import './hospitalFacilities.scss';


export default function HospitalFacilities(props) {
    const imgPath = require.context('../../../assets/Images/Svg',true);
  return (
    <div className='container-fluid hospital-facilities'>
    {
        consultations.consultations.map((data) => (
        <div className='facilities'>
            <div className='icon'>
                <img src={imgPath(`./${data.icon}.svg`)} alt=""></img>
            </div>
            <div className='facility-heading'>
                {data.title}
            </div>
            <div className='facility-description'>
                {data.description}
            </div>
            <div className='custom-btn-group'>
                <Button primaryButton={true}>{data.actions[0]}</Button>
                <Button primaryButton={false} buttonClickHandler={props.handleConsultNow}>{data.actions[1]}</Button>
            </div>
        </div>
        ))
    }
       
    </div>
  )
}
